import type { GetStaticProps, InferGetStaticPropsType } from 'next';
import type { ReactElement } from 'react';

import HtmlContent from '@/components/HtmlContent';
import Layout from '@/components/Landing/Layout';
import Text from '@/components/Text';
import { getTermsOfService } from '@/services/strapi/terms-of-service';
import { documentDateFormatter } from '@/utils/documentDateFormatter';

const TermsOfService = ({
  termsOfService,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { title, createdAt, content } = termsOfService.data;

  return (
    <div className="md:p- mb-10 mt-28 flex w-full flex-col items-center justify-center gap-10 p-2">
      <div className="flex w-full max-w-6xl flex-col items-center justify-start">
        <div className="mb-4 mt-2 flex w-full flex-col">
          <Text variant="h1">{title}</Text>
        </div>
        <Text className="mb-4 mt-2 flex w-full flex-col font-semibold text-neutral-100">
          Last updated: {documentDateFormatter(createdAt)}
        </Text>
        <HtmlContent content={content} variant="cmsContent" />
      </div>
    </div>
  );
};

export default TermsOfService;

export const getStaticProps: GetStaticProps = async () => {
  try {
    const termsOfService = await getTermsOfService();

    return {
      props: { termsOfService },
      revalidate: 10,
    };
  } catch (error) {
    return { notFound: true };
  }
};

TermsOfService.getLayout = (page: ReactElement) => <Layout>{page}</Layout>;
